export default __webpack_public_path__ + "c333a48af11551b93472bae749899fca.png";